(function () {
  'use strict';

  function setProductScope(root) {
    root.querySelectorAll('.pw-product-page').forEach(function (page) {
      page.classList.add('pw2-scope');
      page.setAttribute('data-pw-ui', 'v2');
      page.classList.add('pw-product-engine-ready');
    });
  }

  function updateVariant(select, updateUrl) {
    var option = select.options[select.selectedIndex];
    var page = select.closest('.pw-product-page');
    if (!option || !page) return;

    var currentPrice = page.querySelector('[data-pw-price-current]');
    var comparePrice = page.querySelector('[data-pw-price-compare]');
    var button = page.querySelector('[data-pw-atc]');
    var stock = page.querySelector('[data-pw-stock]');
    var available = option.dataset.available === 'true';
    var compare = option.dataset.comparePrice || '';

    if (currentPrice) currentPrice.textContent = option.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = compare;
      comparePrice.hidden = !compare;
    }

    if (button) {
      button.disabled = !available;
      button.textContent = available ? 'In winkelwagen' : 'Niet beschikbaar';
    }

    if (stock) {
      stock.classList.toggle('pw-stock--unavailable', !available);
      stock.innerHTML = available
        ? '<strong>Beschikbaar voor bestelling</strong><span>Bezorging en aanvullende diensten kiest u hierboven.</span>'
        : '<strong>Tijdelijk niet beschikbaar</strong><span>Neem contact op voor de actuele levertijd.</span>';
    }

    if (updateUrl && window.history && window.URL) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function initVariantPickers(root) {
    root.querySelectorAll('[data-pw-variant-picker]').forEach(function (select) {
      if (select.dataset.pwVariantBound === 'true') return;
      select.dataset.pwVariantBound = 'true';
      updateVariant(select, false);
      select.addEventListener('change', function () {
        updateVariant(select, true);
      });
    });
  }

  function init(root) {
    setProductScope(root);
    initVariantPickers(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
